import { useEffect } from 'react';

import { searchPageLoadUFOExperience } from '@atlassian/search-page/experiences';

export const SearchPageLoadUFOExperienceStart = () => {
	useEffect(() => {
		void searchPageLoadUFOExperience.start();
	}, []);

	return null;
};
